import React, { Fragment, useEffect, useState } from "react";
import { useHistory, Route, Switch, withRouter } from "react-router-dom";

import { CSSTransition } from "react-transition-group";
import { connect } from "react-redux";

import styled from "styled-components";

import firebase from "firebase";
import Header from "./header";

import { SET_STORE_USER } from "../store/reducers/storeUser";
import DB_PATH from "../database/DB_PATH";
import MapAllowedRoutes, { getAllowedRoutes } from "./MapAllowedRoutes";
import navigationItems from "./navigation-items";
import setTokenForStoreUser from "../database/storeUser/setTokenForStoreUser";
import { getToken } from "../utils/NotificationUtil";
import getUser from "../database/user/getUser";
import getCommunity from "../database/community/getCommunity";
import { SET_COMMUNITY } from "../store/reducers/community";
import { Catalog, ShellDemo, StudioDemo } from "../design-system";
import LaunchChecklist from "../components/launchChecklist/LaunchChecklist";

const Wrapper = styled.div`
  width: 100%;
  position: absolute;
  padding: 104px 0px 0px 0px;
  background-color: ${({ theme }) => theme.colors.containerColor};
`;
const Container = styled.div`
  height: 100%;
`;

type Props = {
  history: any;
};
const Router = (props: any) => {
  const { user, setCommunityUser, setCommunity, community } = props;
  const history = useHistory();
  const [allowedRoutes, setAllowedRoutes] = useState(navigationItems);

  const [token, setToken] = useState("");

  // Must run in an effect, not the render body. On iOS Safari FCM is
  // unsupported so `messaging` is null, and getToken() then calls setToken
  // synchronously — doing that during render triggers an infinite re-render
  // loop (React error #301). It also avoids re-requesting the token on every
  // render on browsers where push IS supported.
  useEffect(() => {
    getToken(setToken);
  }, []);

  useEffect(() => {
    if (user) {
      firebase
        .database()
        .ref(`/${DB_PATH.ADMIN_USER}/${user.uid}`)
        .on("value", function (snapshot) {
          var userObject = snapshot.val();

          console.log("UserObject", userObject);
          if (userObject) {
            setCommunityUser(userObject);
            getCommunity(userObject.communityId, setCommunity);
          }
        });

      setAllowedRoutes(getAllowedRoutes(navigationItems, user.role));

      const currentPath = history.location.pathname;
      const isAtRoot = currentPath === "/" || currentPath === "";
      if (isAtRoot) {
        !user.storeId ? history.push("/plans") : history.push("/");
      }
    }
  }, []);

  console.log("Community", community);
  return (
    <Container>
      <Switch>
        <Route path="/design-system" exact>
          <Catalog />
        </Route>
        <Route path="/design-system/shell" exact>
          <ShellDemo />
        </Route>
        <Route path="/design-system/studio" exact>
          <StudioDemo />
        </Route>
        <Route
          render={({ location }) => (
            <Fragment>
              <Header routes={allowedRoutes} />
              <CSSTransition
                key={location.key}
                classNames="fade-enter-active"
                timeout={250}
              >
                <Wrapper>
                  <div style={{ padding: "16px 16px 0" }}>
                    <LaunchChecklist
                      communityId={community?.id}
                      community={community}
                    />
                  </div>
                  <MapAllowedRoutes
                    location={location}
                    routes={allowedRoutes}
                    isAddNotFound
                  />
                </Wrapper>
              </CSSTransition>
            </Fragment>
          )}
        />
      </Switch>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.firebaseUser,
  storeUser: state.storeUser,
  community: state.community,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setCommunity: (store) => dispatch({ type: SET_COMMUNITY, payload: store }),
    setCommunityUser: (value) =>
      dispatch({ type: SET_STORE_USER, payload: value }),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Router));
